import { Model as o } from "../../../model.js";
class r extends o {
  constructor(t) {
    super(), this.amount = t.amount, this.name = t.name, this.rate = t.rate, this.taxId = t.taxId;
  }
}
export {
  r as TicketTaxModel
};
//# sourceMappingURL=ticketTax.model.js.map
